import React, { createContext, useContext } from 'react';

const SplitPanelContext = createContext<
  ((newContent: React.ReactNode) => void) | null
>(null);

export const SplitPanelProvider = SplitPanelContext.Provider;

export function useSplitPanel() {
  const ctx = useContext(SplitPanelContext);
  if (!ctx) {
    throw new Error('Missing SplitPanelProvider');
  }
  return ctx;
}
